import { render } from "./VerifiersReportsList.vue?vue&type=template&id=6b133794&scoped=true"
import script from "./VerifiersReportsList.vue?vue&type=script&lang=js"
export * from "./VerifiersReportsList.vue?vue&type=script&lang=js"

import "./VerifiersReportsList.vue?vue&type=style&index=0&id=6b133794&scoped=true&lang=scss"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b133794"]])

export default __exports__